import { AppDomain } from '@ibk/shared-types';
import { SUPER_APP_STORE_URLS_BY_DOMAIN } from './superAppLinks';
const MOBILE_PATTERNS = [/Android/i, /iPhone/i, /iPad/i];
export function isMobileUserAgent() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    const userAgent = navigator.userAgent;
    return MOBILE_PATTERNS.some(pattern => pattern.test(userAgent));
}
export function isAndroidUserAgent() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return /Android/i.test(navigator.userAgent);
}
export function isIOSUserAgent() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return /iPhone|iPad/i.test(navigator.userAgent);
}
const APP_CONFIG = {
    empresa: {
        customScheme: 'client',
        pathPrefix: 'minha-empresa',
        androidPackage: 'com.thomsonreuters.domino.client',
        storeUrls: SUPER_APP_STORE_URLS_BY_DOMAIN[AppDomain.EMPRESA],
    },
    escritorio: {
        customScheme: 'accountant',
        pathPrefix: 'meu-escritorio',
        androidPackage: 'com.thomsonreuters.domino.accountant',
        storeUrls: SUPER_APP_STORE_URLS_BY_DOMAIN[AppDomain.ESCRITORIO],
    },
};
export function detectAppDomain(apiBaseUrl) {
    const domain = Object.entries(APP_CONFIG).find(([, config]) => apiBaseUrl.includes(config.pathPrefix));
    return domain?.[0] ?? '';
}
function buildCustomSchemeUrl(customScheme, pathPrefix, queryString) {
    const deepLinkPath = `/${pathPrefix}/deeplink`;
    return queryString ? `${customScheme}:${deepLinkPath}?${queryString}` : `${customScheme}:${deepLinkPath}`;
}
function buildAndroidIntentUrl(customScheme, pathPrefix, queryString, packageName, fallbackUrl) {
    const deepLinkPath = `/${pathPrefix}/deeplink`;
    const fullPath = queryString ? `${deepLinkPath}?${queryString}` : deepLinkPath;
    return `intent:/${fullPath}#Intent;scheme=${customScheme};package=${packageName};S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
}
export function getMobileRedirectUrl(appDomain, searchParams) {
    const config = APP_CONFIG[appDomain];
    if (!config) {
        return null;
    }
    const { customScheme, pathPrefix, androidPackage, storeUrls } = config;
    const queryString = searchParams.toString();
    if (isAndroidUserAgent()) {
        return buildAndroidIntentUrl(customScheme, pathPrefix, queryString, androidPackage, storeUrls.android);
    }
    return buildCustomSchemeUrl(customScheme, pathPrefix, queryString);
}
export function getStoreFallbackUrl(appDomain) {
    const config = APP_CONFIG[appDomain];
    if (!config) {
        return null;
    }
    if (isIOSUserAgent()) {
        return config.storeUrls.ios;
    }
    if (isAndroidUserAgent()) {
        return config.storeUrls.android;
    }
    return null;
}
export function redirectToMobileApp(appDomain, searchParams) {
    const redirectUrl = getMobileRedirectUrl(appDomain, searchParams);
    if (!redirectUrl) {
        return;
    }
    if (isAndroidUserAgent()) {
        window.location.href = redirectUrl;
        return;
    }
    if (isIOSUserAgent()) {
        const fallbackUrl = getStoreFallbackUrl(appDomain);
        const startTime = Date.now();
        window.location.href = redirectUrl;
        if (fallbackUrl) {
            setTimeout(() => {
                if (document.hidden || Date.now() - startTime > 2500) {
                    return;
                }
                window.location.href = fallbackUrl;
            }, 2000);
        }
    }
}
